// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"SearchButton--searchButton--3rU1b","searchButton__icon":"SearchButton--searchButton__icon--f_UWt"};